import { call } from '@advanza/api'
import ChangePassword, { ChangePasswordCopy } from '@trustoo/components/login/ChangePassword'
import { getLogoUrls } from '@trustoo/utils/localeUtils'

const COPY: ChangePasswordCopy = {
    title: 'Change password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    repeatPassword: 'Confirm password',
    submit: 'Save password',
    success: 'Your password has been changed.',
    login: 'Log in',
    errors: {
        currentPasswordMissing: 'Enter your current password',
        passwordTooWeak:
            'The password is not strong enough. Make it longer, with less common words, numbers and symbols.',
        passwordsDiffer: 'The passwords are not the same',
        sameAsCurrent: 'Choose a different password than the one you had before.',
        wrongCurrentPassword: 'Your current password is incorrect',
        failed: 'Something went wrong',
    },
    strength: {
        scores: ['Not strong', 'Not strong enough', 'Not strong enough', 'Excellent'],
        hint: 'A good password is hard to guess. Use less common words, no standard capitalization and make creative use of symbols and numbers.',
    },
    tokenError: {
        linkExpired: 'This link is no longer valid. Ask an admin to send you a new password mail.',
        linkInvalid:
            'Something went wrong with this link. Ask an admin to send you a new password mail.',
    },
}

interface ChangePasswordPageProps {
    /** From the link in a password mail; without one, the current password is asked for. */
    token?: string
}

const ChangePasswordPage = ({ token }: ChangePasswordPageProps) => (
    <ChangePassword
        token={token}
        logoUrl={getLogoUrls().default}
        copy={COPY}
        validateToken={(validToken) =>
            call(`Auth/validate-token/${validToken}`, { method: 'post' })
        }
        changePassword={(request) => call('Auth/change-password', { payload: request })}
        getLoginHref={(changedEmail) => `/login?email=${encodeURIComponent(changedEmail)}`}
    />
)

export default ChangePasswordPage
